import { render } from "./CatalogoProductos.vue?vue&type=template&id=0c95d87a&scoped=true"
import script from "./CatalogoProductos.vue?vue&type=script&lang=js"
export * from "./CatalogoProductos.vue?vue&type=script&lang=js"

import "./CatalogoProductos.vue?vue&type=style&index=0&id=0c95d87a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c95d87a"]])

export default __exports__